import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { getRandom, getRangeValue, randomInRange, setRangeValue } from "tsparticles-engine";
import { Life } from "./Options/Classes/Life";
export var LifeUpdater = /*#__PURE__*/function () {
  function LifeUpdater(container) {
    _classCallCheck(this, LifeUpdater);

    this.container = container;
  }

  _createClass(LifeUpdater, [{
    key: "init",
    value: function init(particle) {
      var container = this.container,
          particlesOptions = particle.options,
          lifeOptions = particlesOptions.life;

      if (!lifeOptions) {
        return;
      }

      particle.life = {
        delay: container.retina.reduceFactor ? getRangeValue(lifeOptions.delay.value) * (lifeOptions.delay.sync ? 1 : getRandom()) / container.retina.reduceFactor * 1000 : 0,
        delayTime: 0,
        duration: container.retina.reduceFactor ? getRangeValue(lifeOptions.duration.value) * (lifeOptions.duration.sync ? 1 : getRandom()) / container.retina.reduceFactor * 1000 : 0,
        time: 0,
        count: lifeOptions.count
      };

      if (particle.life.duration <= 0) {
        particle.life.duration = -1;
      }

      if (particle.life.count <= 0) {
        particle.life.count = -1;
      }

      if (particle.life) {
        particle.spawning = particle.life.delay > 0;
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return !particle.destroyed;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options) {
      if (!options.life) {
        options.life = new Life();
      }

      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];
        options.life.load(source === null || source === void 0 ? void 0 : source.life);
      }
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle) || !particle.life) {
        return;
      }

      var life = particle.life;
      var justSpawned = false;

      if (particle.spawning) {
        life.delayTime += delta.value;

        if (life.delayTime >= particle.life.delay) {
          justSpawned = true;
          particle.spawning = false;
          life.delayTime = 0;
          life.time = 0;
        } else {
          return;
        }
      }

      if (life.duration === -1) {
        return;
      }

      if (particle.spawning) {
        return;
      }

      if (justSpawned) {
        life.time = 0;
      } else {
        life.time += delta.value;
      }

      if (life.time < life.duration) {
        return;
      }

      life.time = 0;

      if (particle.life.count > 0) {
        particle.life.count--;
      }

      if (particle.life.count === 0) {
        particle.destroy();
        return;
      }

      var canvasSize = this.container.canvas.size,
          widthRange = setRangeValue(0, canvasSize.width),
          heightRange = setRangeValue(0, canvasSize.width);
      particle.position.x = randomInRange(widthRange);
      particle.position.y = randomInRange(heightRange);
      particle.spawning = true;
      life.delayTime = 0;
      life.time = 0;
      particle.reset();
      var lifeOptions = particle.options.life;

      if (lifeOptions) {
        life.delay = getRangeValue(lifeOptions.delay.value) * 1000;
        life.duration = getRangeValue(lifeOptions.duration.value) * 1000;
      }
    }
  }]);

  return LifeUpdater;
}();